import { render, staticRenderFns } from "./DialogInstructors.vue?vue&type=template&id=3959ee18&"
import script from "./DialogInstructors.vue?vue&type=script&lang=js&"
export * from "./DialogInstructors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports